<template>

  <div class="c-pagetop" :class="{ 'c-pagetop--shape': content.image }">

    <div class="o-layout o-layout--middle">

      <div class="o-layout__item u-6/10@tablet" v-if="content.image">
          <Shape type="pagetop" :img="content.image" :imgOverlay="false" :bg="false" :id="Math.random().toString(36).substring(7)" />
      </div>

      <div class="o-layout__item" :class="content.image ? 'u-4/10@tablet' : 'u-6/10@tablet u-push-2/10@tablet'">
        <div class="c-pagetop__content">
          <h1 :class="content.image ? '' : 'u-align-center'">{{ content.title }}</h1>
          <div v-html="content.content"></div>
          <Button v-if="content.button" class="u-margin-top" :content="content.button" />

          <Shape v-if="content.image" type="pagetop" :img="false" :imgOverlay="false" :bg="true" :id="Math.random().toString(36).substring(7)" />
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import Shape from '@/components/Shape'
import Button from '@/components/Button'

export default {
  name: 'Pagetop',
  props: ['content'],

  components: {
    Shape,
    Button
  }
}
</script>
